<template>
	<div class="product-info">
		<!-- 导航 -->
		<van-nav-bar
		  title="商品详情"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/>
		<!-- 详情信息 -->
		<div class="info-block">
			<van-cell title="是否上传">
			  <template #right-icon>
					<van-button color="#409eff" size="mini" v-if="status == 0">未上传</van-button>
					<van-button color="#f56c6c" size="mini" v-if="status == 1">已上传</van-button>
			  </template>
			</van-cell>
			<van-cell title="是否上传">
			  <template #right-icon>
					<van-button color="#409eff" size="mini" v-if="lock == 0">未锁定</van-button>
					<van-button color="#f56c6c" size="mini" v-if="lock == 1">已锁定</van-button>
			  </template>
			</van-cell>
			<van-cell title="添加日期" :value="addTime" />
			<div v-if="attributeList.length > 0">
				<van-cell title="商品名称" :value="attributeList[0].goods_name" />
				<van-cell title="规格" value="暂无规格" />
				<van-cell title="库存" :value="attributeList[0].goods_storage" />
				<van-cell title="商品图片">
				  <template #right-icon>
				    <van-image
				      width="70"
				      height="70"
				      :src="attributeList[0].goods_image"
				    />
				  </template>
				</van-cell>
			</div>
			<div v-else>
				<van-cell title="商品名称" value="无" />
				<van-cell title="规格" value="暂无规格" />
				<van-cell title="库存" value="无" />
				<van-cell title="商品图片" value="无" />
			</div>
		</div>
	</div>
</template>

<script>
import { getGoodsAttribute } from '../../../api/sale'
export default {
  name: 'ProductInfo',
	components: {
	},
  data () {
    return {
			// 商品属性列表
			attributeList: [],
			// 是否上传
			status: 0,
			// 是否锁定
			lock: 0,
			// 添加时间
			addTime: ''
    }
  },
	methods: {
		// 返回上一页
		goBack () {
			this.$router.go(-1)
		}
	},
	created () {
		this.status = this.$route.params.status
		this.lock = this.$route.params.lock
		this.addTime = this.$route.params.addTime
		getGoodsAttribute(this.$route.params.commonId).then(res => {
			this.attributeList = res.result
		}).catch(error=>{
			// 
		})
	}
}
</script>

<style lang="scss" scoped>
.product-info {
	font-size: 14px;
}
.product-info   ::v-deep.van-nav-bar {
	background-color: #e93b3d;
	color: white;
	.van-icon-arrow-left, .van-nav-bar__text, .van-nav-bar__title {
		color: white;
	}
}
</style>
